import React from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { MapPin } from 'lucide-react';
import { citiesAPI } from '../services/api';
import SEOHead from '../components/SEOHead';

const Cities = () => {
  const { data: cities = [], isLoading } = useQuery({ queryKey: ['cities'], queryFn: () => citiesAPI.getAll().then((r) => r.data) });

  if (isLoading) {
    return (
      <>
        <SEOHead
          title="2026 FIFA World Cup Host Cities - WorldCup Fan Planner"
          description="Explore all 2026 FIFA World Cup host cities in the USA, Canada, and Mexico—travel tips, guides, and fan resources."
        />
        <div className="p-8 text-center">Loading...</div>
      </>
    );
  }

  return (
    <>
      <SEOHead
        title="2026 FIFA World Cup Host Cities - WorldCup Fan Planner"
        description="Explore all 2026 FIFA World Cup host cities in the USA, Canada, and Mexico—travel tips, guides, and fan resources."
      />
    <div className="max-w-7xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">2026 FIFA World Cup host cities</h1>
      <p className="text-gray-600 dark:text-gray-400 mb-3">
        Explore every North American host city with fan guides, attractions, tours, and maps. Each guide links to local stadiums and the wider match schedule.
      </p>
      <p className="text-sm text-gray-600 dark:text-gray-400 mb-6">
        New to trip planning? Try the{' '}
        <Link to="/itinerary-planner" className="text-amber-600 dark:text-amber-400 hover:underline font-medium">AI itinerary planner</Link>
        {' '}or{' '}
        <Link to="/fan-meetups" className="text-amber-600 dark:text-amber-400 hover:underline font-medium">fan meetups</Link>
        .
      </p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {cities.map((c) => (
          <Link key={c.id} to={`/cities/${c.slug || c.id}`} className="block p-5 rounded-xl bg-white dark:bg-gray-800/80 border border-gray-200 dark:border-gray-700 shadow-sm hover:shadow-md hover:border-amber-400 dark:hover:border-amber-600 transition-all">
            <h3 className="font-bold text-lg">{c.name}</h3>
            <p className="text-sm text-gray-500 dark:text-gray-400 flex items-center mt-1"><MapPin className="h-4 w-4 mr-1" />{c.country}</p>
            <p className="text-sm text-gray-600 dark:text-gray-300 mt-2 line-clamp-2">{c.description}</p>
          </Link>
        ))}
      </div>
    </div>
    </>
  );
};

export default Cities;
